module.exports = __webpack_public_path__ + "img/employee_ic.ce6ec271.svg";